import { render, staticRenderFns } from "./AddNewAddressDialog.vue?vue&type=template&id=bc13af72&scoped=true"
import script from "./AddNewAddressDialog.vue?vue&type=script&lang=js"
export * from "./AddNewAddressDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc13af72",
  null
  
)

export default component.exports